import { render, staticRenderFns } from "./copyProductDialog.vue?vue&type=template&id=06176230&scoped=true&"
import script from "./copyProductDialog.vue?vue&type=script&lang=js&"
export * from "./copyProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./copyProductDialog.vue?vue&type=style&index=0&id=06176230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06176230",
  null
  
)

export default component.exports